module.exports = __webpack_public_path__ + "media/scripts/pages/join/assets/media/why/globe-e0bace3ac28c4a6a5896cce7efb01400.svg";